 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"bindtransactor~checkacct~dividend~frame~infocollection~login~modifyinfo~outframe~remitinfo~statement~555f24d0":"bindtransactor~checkacct~dividend~frame~infocollection~login~modifyinfo~outframe~remitinfo~statement~555f24d0","bindtransactor":"bindtransactor","checkacct~invchange~risktest":"checkacct~invchange~risktest","checkacct~modifyinfo":"checkacct~modifyinfo","checkacct~taxes":"checkacct~taxes","checkacct":"checkacct","modifyinfo":"modifyinfo","taxes":"taxes","dividend":"dividend","frame":"frame","infocollection":"infocollection","login":"login","outframe":"outframe","remitinfo":"remitinfo","statement":"statement","traderecord":"traderecord","buyfund~changefund~privatebuy":"buyfund~changefund~privatebuy","buyfund":"buyfund","changefund":"changefund","privatebuy":"privatebuy","cfund":"cfund","changetpwd":"changetpwd","invchange":"invchange","risktest":"risktest","errgeneral":"errgeneral","errnetwork":"errnetwork","fund":"fund","fundmarket":"fundmarket","home":"home","hotfund~privatehot":"hotfund~privatehot","hotfund":"hotfund","privatehot":"privatehot","infoPublish":"infoPublish","knowdetail":"knowdetail","myprivate":"myprivate","orginfo":"orginfo","privateassets":"privateassets","privatefund":"privatefund","risk":"risk","sellfund":"sellfund"}[chunkId]||chunkId) + "." + {"bindtransactor~checkacct~dividend~frame~infocollection~login~modifyinfo~outframe~remitinfo~statement~555f24d0":"0120da28","bindtransactor":"283e05c2","checkacct~invchange~risktest":"cbf36245","checkacct~modifyinfo":"b9c6e9a8","checkacct~taxes":"8bab2601","checkacct":"c3ed2620","modifyinfo":"3f55b9c6","taxes":"9b9184da","dividend":"6eb977be","frame":"98535169","infocollection":"f5e80b71","login":"e51cdcfa","outframe":"7f185af9","remitinfo":"624cc047","statement":"c6133b6d","traderecord":"860969f1","buyfund~changefund~privatebuy":"0623b82a","buyfund":"78117b62","changefund":"e1e78cb5","privatebuy":"db116c73","cfund":"a711118f","changetpwd":"dfab4009","invchange":"de4a1117","risktest":"6cf68705","chunk-2b6b483e":"636f2165","errgeneral":"ec115884","errnetwork":"2d8164c4","fund":"96a14efd","fundmarket":"e2abd106","home":"9661d824","hotfund~privatehot":"ab89566b","hotfund":"6d9ecf27","privatehot":"a492faea","infoPublish":"c14f387a","knowdetail":"97b8b39e","myprivate":"f5b0718e","orginfo":"063ceea0","privateassets":"5777b4c3","privatefund":"edd2d384","risk":"da1415bc","sellfund":"e2612477","chunk-dbf93c88":"e63c85ff","chunk-fc9bbdf0":"569c423f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"bindtransactor":1,"checkacct~invchange~risktest":1,"checkacct~modifyinfo":1,"checkacct~taxes":1,"checkacct":1,"modifyinfo":1,"taxes":1,"dividend":1,"frame":1,"infocollection":1,"login":1,"outframe":1,"remitinfo":1,"statement":1,"traderecord":1,"buyfund~changefund~privatebuy":1,"buyfund":1,"changefund":1,"privatebuy":1,"cfund":1,"changetpwd":1,"invchange":1,"risktest":1,"chunk-2b6b483e":1,"errgeneral":1,"errnetwork":1,"fundmarket":1,"home":1,"hotfund~privatehot":1,"hotfund":1,"privatehot":1,"infoPublish":1,"knowdetail":1,"myprivate":1,"orginfo":1,"privateassets":1,"privatefund":1,"risk":1,"sellfund":1,"chunk-dbf93c88":1,"chunk-fc9bbdf0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"bindtransactor~checkacct~dividend~frame~infocollection~login~modifyinfo~outframe~remitinfo~statement~555f24d0":"bindtransactor~checkacct~dividend~frame~infocollection~login~modifyinfo~outframe~remitinfo~statement~555f24d0","bindtransactor":"bindtransactor","checkacct~invchange~risktest":"checkacct~invchange~risktest","checkacct~modifyinfo":"checkacct~modifyinfo","checkacct~taxes":"checkacct~taxes","checkacct":"checkacct","modifyinfo":"modifyinfo","taxes":"taxes","dividend":"dividend","frame":"frame","infocollection":"infocollection","login":"login","outframe":"outframe","remitinfo":"remitinfo","statement":"statement","traderecord":"traderecord","buyfund~changefund~privatebuy":"buyfund~changefund~privatebuy","buyfund":"buyfund","changefund":"changefund","privatebuy":"privatebuy","cfund":"cfund","changetpwd":"changetpwd","invchange":"invchange","risktest":"risktest","errgeneral":"errgeneral","errnetwork":"errnetwork","fund":"fund","fundmarket":"fundmarket","home":"home","hotfund~privatehot":"hotfund~privatehot","hotfund":"hotfund","privatehot":"privatehot","infoPublish":"infoPublish","knowdetail":"knowdetail","myprivate":"myprivate","orginfo":"orginfo","privateassets":"privateassets","privatefund":"privatefund","risk":"risk","sellfund":"sellfund"}[chunkId]||chunkId) + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/agate/org/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
